module.exports = __webpack_public_path__ + "static/media/paserg-border-tree.95638340.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/images/paserg/paserg-border-tree.png
// module id = 216
// module chunks = 0